import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Asset } from './asset.dto';
import { ObservableSyncService } from '../sync/observable-sync.service';
import { ChangeTyped, mapSnapshotToDtos, QueryService, SearchResult } from '@damofire/data-commons';
import { ObservableAssetService } from './asset-observable.service';
import { TypedDesQuery } from '../des.dto';
import { ObservableNoteService } from '../note/note-observable.service';

@Injectable()
export class IdbObservableAssetService extends ObservableAssetService {
  private static readonly ASSETS_STORE = 'assets';

  constructor(
    protected readonly observableSyncService: ObservableSyncService<Asset>,
    protected readonly observableNoteService: ObservableNoteService,
  ) {
    super(observableNoteService);
  }

  observeById(divisionId: string, id: string): Observable<ChangeTyped<Asset>> {
    return this.observableSyncService.toObservableById(IdbObservableAssetService.ASSETS_STORE, divisionId, id);
  }

  observeBySection(divisionId: string, section: string): Observable<ChangeTyped<Asset>[]> {
    return this.observableSyncService.toObservable(IdbObservableAssetService.ASSETS_STORE, divisionId, (assets) => assets.filter((a) => a.section === section));
  }

  observeBySystem(divisionId: string, system: number): Observable<ChangeTyped<Asset>[]> {
    return this.observableSyncService.toObservable(IdbObservableAssetService.ASSETS_STORE, divisionId, (assets) => assets.filter((a) => a.system === system));
  }

  noteableSearch(id: string, sQuery: TypedDesQuery): Observable<SearchResult<Asset>> {
    let previousResults: Asset[] = [];
    return this.observableSyncService.toObservable(IdbObservableAssetService.ASSETS_STORE, id).pipe(
      map((changes) => {
        mapSnapshotToDtos(previousResults, changes);
        const searchResults = QueryService.searchCollection<Asset>(previousResults, sQuery, this.SEARCH_FIELDS);
        previousResults = searchResults.result;
        return searchResults;
      }),
    );
  }
}
